module.exports = __webpack_public_path__ + "static/media/mid_rain.cf364b4a.jpg";